import Form from 'src/utils/Form.js'

class Alert extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get('alerts/' + this.id + '/edit').then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get('alerts' + '?' + parameters).then(then)
  }

  static onLogin(then) {
    return new Form().get('auth/alerts').then(then)
  }

  static onLanding(then) {
    return new Form().get('dashboard/alerts').then(then)
  }

  create(then) {
    return super.post('alerts').then(then)
  }

  update(then) {
    return super.patch(`alerts/${this.id}`).then(then)
  }

  updateInline(then) {
    return super.put(`alerts/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`alerts/${this.id}`).then(then)
  }
}

export default Alert
